import { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { Switch } from 'formik-mui';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Checkbox } from "formik-mui";

// material
import { Stack, TextField, Typography, Button, Grid, FormLabel, FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import Rating from '@mui/material/Rating';
import { LoadingButton } from '@mui/lab';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
//
import { addReview, API } from 'src/Redux/actions/reviewsActions';
// import { createImageFile } from 'src/Redux/helpers/generalHelper';
//
import RichTextEditor from 'src/components/RichTextEditor';
import { useEffect } from 'react';
import { getActiveCountries, getCountries, getServicesWithCategories } from 'src/api/api';
// ----------------------------------------------------------------------
const validTypes = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/svg+xml',
  'image/gif',
  'image/webp'
]; // Image Validation

export default function AddReview() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [thumbnail, setThumbnail] = useState('');
  // Get Countries
  const [countryLoading, setCountryLoading] = useState(false);
  const [countryData, setCountryData] = useState([]);
  const [serviceValue, setServiceValue] = useState('');
  const [serviceLoading, setServiceLoading] = useState(false);
  const [services, setServices] = useState([]);
  const [servicesCategory, setServicesCategory] = useState([]);
  const [serviceCategoryLoading, setServiceCategoryLoading] = useState(false);

  // Get ALL Services
    useEffect(() => {
      setServiceLoading(true);
      const promise = getServicesWithCategories();
      Promise.resolve(promise).then((data) => {
        // console.log('data', data);
        if (data.success) {
          const services = data?.services;
          if (services && services?.length) {
            setServices(data?.services);
          }
          setServiceLoading(false);
        } else {
          setServices([]);
          setServiceLoading(false);
        }
      });
    }, []);
    // Get ALL Countries
    useEffect(() => {
      setCountryLoading(true);
      const promise = getActiveCountries();
      Promise.resolve(promise).then((data) => {
        if (data.success) {
          const countries = data?.countries;
        if (countries && countries?.length) {
            setCountryData(data?.countries);
          }
          setCountryLoading(false);
        } else {
          setCountryData([]);
          setCountryLoading(false);
        }
      });
    }, []);
    useEffect(() => {
        const data = services?.find((item) => {
          return item._id == serviceValue;
        });
    
        setServiceCategoryLoading(true);
        setServicesCategory(data?.categories);
        setTimeout(() => {
          setServiceCategoryLoading(false);
        }, 1000);
      }, [serviceValue]);
    
  // Validation Schema for From
  const ReviewSchema = Yup.object().shape({
    lang: Yup.string().required('Language is required'),
    authorEmail: Yup.string()
    .required('Author email is required')
    .min(2, 'Email must be at least 2 characters')
    .max(125, 'Email cannot exceed 125 characters'),
    review: Yup.string().required('Review description is required'),
    category: Yup.array().when("isHomePg", {
      is: false,
      then: Yup.array()
        .of(Yup.string().required())
        .min(1, "At least one category is required"),
      otherwise: Yup.array().nullable(),
    }),
    service: Yup.string().when("isHomePg", {
      is: false,
      then: Yup.string().required("Service is required"),
      otherwise: Yup.string().nullable(),
    })
  });

  return (
    <Grid container mx="auto" justifyContent="center">
      <Grid lg={8} md={8} xs={10} sm={10}>
        <Card sx={{ minWidth: 275, boxShadow: 3, borderRadius: 1, border: '1px solid #929eaa6b' }}>
          <CardContent>
            <Formik
              enableReinitialize={true}
              initialValues={{
                lang: '',
                service: '',
                category: [],
                authorName: '',
                authorEmail: '',
                authorUrl: '',
                rating: 5,
                profile_picture: '',
                review: '',
                active:false,
                isHomePg:false,
              }}
              validationSchema={ReviewSchema}
              onSubmit={async (values) => {
                setLoading(true);
                const submitValues = { ...values };
                if (submitValues.isHomePg) {
                  submitValues.service = '';
                  submitValues.category = [];
                }
                // Form Data
                const formData = new FormData();
                Object.entries(submitValues).forEach(([key, value]) => {
                  if (Array.isArray(value)) {
                    value.forEach((v) => formData.append(`${key}[]`, v));
                  } else {
                    formData.append(key, value);
                  }
                });
                dispatch(addReview(formData, navigate, setLoading));
              }}
            >
              {({ errors, touched, setFieldValue, values }) => (
                <Form autoComplete="off" style={{ padding: 'inherit' }}>
                  <Typography variant="h4" gutterBottom>
                    Add New Review
                  </Typography>
                  <Stack spacing={1} mt={2}>
                    <FormControl>
                    <FormLabel id="lang">Language</FormLabel>
                      {countryLoading ? <CircularProgress size={30} />
                       :
                       <Field
                        name="lang"
                        id="lang"
                        as={Select}
                        placeholder="Select Language"
                        sx={{ width: '95%' }}
                        onChange={(event) => setFieldValue('lang', event.target.value)}
                      >
                        {
                          countryData.map((item,i)=>(
                            <MenuItem key={i} value={item.countrySlug}>{item.countryName}</MenuItem>
                          ))
                        }
                      </Field>}
                       {errors.lang && touched.lang ? (
                          <div className="error-color">{errors.lang}</div>
                        ) : null}
                    </FormControl>
                     <FormControlLabel
                      control={
                        <Field
                          component={Checkbox}
                          type="checkbox"
                          name="isHomePg"
                        />
                      }
                      label="Show on Home Page"
                    />

                    {!values.isHomePg && (
                      <>
                        <FormLabel id="service">Service Type</FormLabel>

                        {serviceLoading ? (
                          <CircularProgress size={30} />
                        ) : (
                          <Field
                            name="service"
                            select
                            defaultValue=""
                            component={TextField}
                            onChange={(e) => {
                              setFieldValue("service", e.target.value);
                              setServiceValue(e.target.value);
                            }}
                            sx={{ width: "95%" }}
                            label="Select Value"
                          >
                            <MenuItem value="">Not Selected</MenuItem>
                            {services?.map((item) => (
                              <MenuItem key={item._id} value={item._id} label={item.name}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Field>
                          
                        )}

                        <p style={{ color: '#2065d1' }}>
                          Select Service Type first then Category.
                        </p>
                        {errors.service && touched.service ? (
                          <div className="error-color">{errors.service}</div>
                        ) : null}
                        
                        <FormLabel id="category">Category</FormLabel>

                        {serviceCategoryLoading && <CircularProgress size={30} />}

                        {!serviceCategoryLoading && (
                          <Autocomplete
                            multiple
                            id="category"
                            options={servicesCategory || []}
                            getOptionLabel={(option) => option.name}
                            value={servicesCategory?.filter((item) => values.category.includes(item._id)) || []}
                            onChange={(event, newValue) => {
                              const selectedIds = newValue.map((item) => item._id);
                              setFieldValue("category", selectedIds);
                            }}
                            disabled={!values.service}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Categories"
                                placeholder="Choose categories"
                                sx={{ width: "95%" }}
                              />
                            )}
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => (
                                <Chip
                                  label={option.name}
                                  {...getTagProps({ index })}
                                  key={option._id}
                                />
                              ))
                            }
                          />
                        )}                         
                        {errors.category && touched.category ? (
                          <div className="error-color">{errors.category}</div>
                        ) : null}
                      </>
                    )}
                    <FormLabel id="authorName">Author Name</FormLabel>
                    <Field
                      type="text"
                      id="authorName"
                      name="authorName"
                      className="input-style"
                      placeholder="Enter Author Name"
                    />
                    {errors.authorName && touched.authorName ? (
                      <div className="error-color">{errors.authorName}</div>
                    ) : null}
                    <FormLabel id="authorEmail">Author Email</FormLabel>
                    <Field
                      type="text"
                      id="authorEmail"
                      name="authorEmail"
                      className="input-style"
                      placeholder="Enter Author Email"
                    />
                    {errors.authorEmail && touched.authorEmail ? (
                      <div className="error-color">{errors.authorEmail}</div>
                    ) : null}
                    <FormLabel id="authorUrl">Author URL</FormLabel>
                    <Field
                      type="text"
                      id="authorUrl"
                      name="authorUrl"
                      className="input-style"
                      placeholder="Enter Author URL"
                    />
                    {errors.authorUrl && touched.authorUrl ? (
                      <div className="error-color">{errors.authorUrl}</div>
                    ) : null}
                    <FormLabel id="review">Review Description</FormLabel>
                    <Field
                      as="textarea"
                      id="review"
                      name="review"
                      className="input-style"
                      style={{height:"auto"}}
                      sx={{ width: '95%'}}
                      rows={5}
                      placeholder="Enter Review Description"
                    />
                    {errors.review && touched.review ? (
                      <div className="error-color">{errors.review}</div>
                    ) : null}
                    <FormLabel id="rating">Rating</FormLabel>
                    <Rating
                      name="simple-controlled"
                      value={values.rating}
                      onChange={(e, newValue) => {
                        setFieldValue('rating', newValue);
                      }}
                    />
                    <FormLabel id="active">Active</FormLabel>
                      <FormControlLabel
                      
                        control={<Field component={Switch} type="checkbox" name="active" />}
                        label={values.active === true ? 'Active' : 'In-Active'}
                      />
                    <Grid container>
                      <Grid xs={6} sm={6} md={6} lg={6} mt={2}>
                        <FormLabel id="profile_picture"> Upload Profile Picture</FormLabel>
                        {thumbnail && (
                          <img
                            alt="new image"
                            src={thumbnail}
                            width={250}
                            height={250}
                            style={{ objectFit: 'contain', objectPosition: 'top center' }}
                          />
                        )}
                        <TextField
                          sx={{ mt: 1 }}
                          id="file"
                          name="profile_picture"
                          type="file"
                          onChange={(e) => {
                            const image = e.target.files[0];
                            if (!validTypes.includes(image.type)) {
                              toast.error(
                                'Please select an image, allowed file types are .jpg, .jpeg & .png.'
                              );
                              return false;
                            }
                            const fileReader = new FileReader();
                            fileReader.onload = () => {
                              if (fileReader.readyState === 2) {
                                setFieldValue('profile_picture', image);
                                setThumbnail(fileReader.result);
                              }
                            };
                            fileReader.readAsDataURL(image);
                          }}
                        />
                        {errors.profile_picture && touched.profile_picture ? (
                          <div className="error-color">{errors.profile_picture}</div>
                        ) : null}
                      </Grid>
                    </Grid>
                  </Stack>
                  <Grid container>
                    <Grid xs={4} sm={4} md={3} lg={2} mt={3}>
                      <LoadingButton
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                        loading={loading}
                      >
                        Submit
                      </LoadingButton>
                    </Grid>
                    <Grid xs={4} sm={4} md={3} lg={2} ml={2} mt={3}>
                      <Button
                        fullWidth
                        size="large"
                        variant="contained"
                        color="error"
                        component={RouterLink}
                        to="/dashboard/reviews"
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
